import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ForgotPassword from './pages/ForgotPassword';
import Inregistrare from './pages/Inregistrare';
import PoliticaConfidentialitate from './pages/PoliticaConfidentialitate';
import TermeniConditii from './pages/TermeniConditii';
import Help from './pages/Help';
import './App.css';

function PrivateRoute({ children }) {
  return localStorage.getItem('token') ? children : <Navigate to="/login" />;
}

// A doua linie de aparare pentru problema "back-ul telefonului scoate din aplicatie
// la login" - chiar daca navigarea dupa autentificare foloseste deja { replace:true }
// (nu mai lasa /login in istoric), userul poate ajunge oricum pe /login prin alte cai
// (bookmark, tastare URL, restaurare tab). Daca e deja autentificat, il trimitem direct
// inapoi in aplicatie, in loc sa-i aratam din nou formularul de login.
function PublicOnlyRoute({ children }) {
  return localStorage.getItem('token') ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<PublicOnlyRoute><Login /></PublicOnlyRoute>} />
        <Route path="/uitat-parola" element={<ForgotPassword />} />
        <Route path="/inregistrare" element={<Inregistrare />} />
        <Route path="/confidentialitate" element={<PoliticaConfidentialitate />} />
        <Route path="/termeni" element={<TermeniConditii />} />
        <Route path="/help" element={<Help />} />
        <Route path="/*" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
      </Routes>
    </BrowserRouter>
  );
}
